export function defaultPayload() {
  return {
    ro: {},
    en: {},
    contactInfo: {},
    servicePages: { ro: {}, en: {} },
  };
}

export function normalizePayload(parsed) {
  const base = defaultPayload();
  return {
    ro: typeof parsed.ro === "object" && parsed.ro !== null && !Array.isArray(parsed.ro) ? parsed.ro : base.ro,
    en: typeof parsed.en === "object" && parsed.en !== null && !Array.isArray(parsed.en) ? parsed.en : base.en,
    contactInfo:
      typeof parsed.contactInfo === "object" && parsed.contactInfo !== null && !Array.isArray(parsed.contactInfo)
        ? parsed.contactInfo
        : base.contactInfo,
    servicePages: {
      ro:
        parsed.servicePages?.ro && typeof parsed.servicePages.ro === "object" && !Array.isArray(parsed.servicePages.ro)
          ? parsed.servicePages.ro
          : base.servicePages.ro,
      en:
        parsed.servicePages?.en && typeof parsed.servicePages.en === "object" && !Array.isArray(parsed.servicePages.en)
          ? parsed.servicePages.en
          : base.servicePages.en,
    },
  };
}

export async function fetchSitePayload() {
  const r = await fetch("/api/site-content.php", { cache: "no-store", credentials: "include" });
  const j = await r.json();
  return normalizePayload({
    ro: j.ro || {},
    en: j.en || {},
    contactInfo: j.contactInfo || {},
    servicePages: {
      ro: j.servicePages?.ro || {},
      en: j.servicePages?.en || {},
    },
  });
}
